import extendNode from '../extendNode.mjs'
import useCategoryNode from '../_CATEGORY/useCategoryNode.jsx'
import meta from './metaIsrfUc.mjs'

export default () => {
    const CategoryNode = useCategoryNode()

    return extendNode(CategoryNode, {
        ...meta,

        canLinkType(map, node, type) {
            return 'UC' === type
        },

        menuItemsInsertProduct(map, node) {
            return [
                {type: 'UC'},
            ]
        }
    })
}
